module.exports = __webpack_public_path__ + "static/media/visualvm-logo.7bfe328b.png";